import { useQuery } from "@tanstack/react-query";
import { makeRequest } from "@/utils/makeRequest";
import type { TransactionQuote } from "@/interfaces/transaction";

type QuoteParams = {
  domain: "transfer" | "swap" | "withdrawal" | "trade" | "p2p" | string;
  amount: number;
  fromCurrency?: string;
  toCurrency?: string;
  assetId?: string;
};

export function useTransactionQuote(
  params: QuoteParams | null,
  enabled = true,
) {
  const query = useQuery<TransactionQuote>({
    queryKey: ["transaction-quote", params],
    queryFn: async () => {
      const res = await makeRequest.post("/transaction/quote", params);
      return res.data;
    },
    enabled:
      enabled &&
      !!params &&
      !!params.amount &&
      Number(params.amount) > 0 &&
      !!params.fromCurrency,
    staleTime: 10_000, // optional: prevents refetch spam
    gcTime: 60_000,
    retry: 1,
  });

  return {
    quote: query.data,
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
